module.exports = __webpack_public_path__ + "static/12-thumb-330d1125ee84435d230b1b54d56929c3.jpg";